var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('countTo',{ref:"counter",attrs:{"startVal":_vm.startValue,"endVal":_vm.endValue,"duration":_vm.period,"autoplay":_vm.autoplay}})}
var staticRenderFns = []

export { render, staticRenderFns }